import { render } from "./PopularManufacturerModels.vue?vue&type=template&id=230ff9fe"
import script from "./PopularManufacturerModels.vue?vue&type=script&lang=js"
export * from "./PopularManufacturerModels.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__